const translations = {
  en: {
    po_digital_consent: "I expressly agree that the digital service I purchase will be made available immediately after payment, and I understand that starting to use the service may affect my right of withdrawal.",
    show_translation: "Show translation",
    hide_translation: "Hide translation",
    lesson_answers_translation: "Here are the correct answers. Your score is shown at the top, and the correct option for each question is marked in green.",
    // Login
    login_title: "Sign In",
    login_subtitle: "Sign in to your account",
    email: "Email",
    password: "Password",
    login_btn: "Sign In",
    no_account: "Don't have an account?",
    register_link: "Sign Up",
    fill_all_fields: "Please fill in all fields",
    login_success: "Login successful!",
    login_failed: "Login failed",
    // Register
    register_title: "Sign Up",
    register_subtitle: "Create your free account",
    full_name: "Full Name",
    full_name_placeholder: "Your Full Name",
    identity_no: "ID Number (Optional)",
    identity_no_placeholder: "ID Number",
    password_confirm: "Confirm Password",
    register_btn: "Sign Up",
    have_account: "Already have an account?",
    login_link: "Sign In",
    fill_required: "Please fill in the required fields",
    passwords_not_match: "Passwords do not match",
    password_min_length: "Password must be at least 6 characters",
    register_success: "Registration successful!",
    register_failed: "Registration failed",
    native_language: "Native Language:",
    select_language: "Select language",
    // Dashboard
    hello: "Hello,",
    logout: "Logout",
    welcome: "Welcome!",
    continue_practice: "Continue practicing",
    active_package: "Active Package",
    purchase_date: "Purchase",
    start_date: "Start",
    end_date: "End",
    remaining_days: "Remaining",
    days: "days",
    remaining_sessions: "Remaining Sessions",
    select_lesson: "SELECT THE LESSON YOU WANT TO START",
    session_start_failed: "Failed to start session",
    remaining_credits: "Remaining Credits",
    start_practice: "Start Practice",
    listen_lesson: "Listen to Lesson",
    lesson_preparing: "Emma is preparing your lesson...",
    lesson_please_wait: "This will take just a moment.",
    lesson_replay: "Replay",
    lesson_back: "Back to Dashboard",
    lesson_now_playing: "Emma is teaching",
    lesson_score: "Score",
    lesson_correct: "Correct",
    lesson_incorrect: "Incorrect",
    lesson_your_answer: "Your answer",
    lesson_correct_answer: "Correct answer",
    lesson_not_answered: "Not answered",
    insufficient_credits: "You don't have enough credits.",
    lesson_next: "Next",
    lesson_prev: "Back",
    lesson_finish: "Finish",
    payment_start_failed: "Failed to start payment",
    combo_packages: "Combo Packages",
    combo_subtitle: "Get multiple levels together and save",
    discount: "DISCOUNT",
    combo: "Combo",
    included_packages: "Included packages:",
    buy_combo: "Buy Combo",
    select_package: "Select Package",
    select_package_subtitle: "Start by choosing the package that suits your level",
    sessions_count: "sessions",
    total_credits_label: "Total Credits",
    minutes_per_session: "min/session",
    credit_rule_lesson: "1 lesson = 5 credits",
    credit_rule_practice: "1 practice = 10 credits",
    overall_performance: "Overall Performance",
    progress_report: "Progress Report",
    total_sessions: "Total Sessions",
    best_score: "Best Score",
    average_score: "Correct Answers",
    session_history: "Session History",
    lesson_breakdown: "Performance by Lesson",
    minutes: "min",
    days_access: "days access",
    po_title: "Order Confirmation",
    po_summary: "Order Summary",
    po_included: "Included packages",
    po_total: "Total",
    po_vat_note: "All applicable taxes included.",
    po_pay_method: "Payment method: Credit / debit card",
    po_agree_intro: "I have read and accept:",
    po_terms: "Terms of Use",
    po_privacy: "Privacy Policy",
    po_refund: "Refund Policy",
    po_and: "and",
    po_secure: "Secure payment with 3D Secure",
    po_proceed: "Proceed to Payment",
    po_cancel: "Cancel",
    ai_practice: "AI-powered practice",
    buy: "Buy",
    my_languages: "My Languages",
    add_language: "Add another language",
    language_switched: "Language switched",
    add_language_title: "Add a new language",
    choose_language_to_add: "Choose the language you want to learn",
    tagline: "The smartest way to speak",
    // Practice Session
    emma_speaking: "EMMA IS SPEAKING",
    press_speak: "PRESS - SPEAK",
    stop_speaking: "STOP SPEAKING",
    please_wait: "PLEASE WAIT...",
    cant_hear: "I COULDN'T HEAR YOU",
    cant_hear_retry: "I couldn't hear you. Can you say it again?",
    repeat_correct: "REPEAT THE CORRECT ANSWER",
    listening_to_you: "LISTENING TO YOU",
    repeat_please: "PLEASE REPEAT",
    full_sentence_answer: "ANSWER IN A FULL SENTENCE",
    exit_session: "Exit",
    mic_error: "Could not access microphone",
    connection_error: "Connection Error",
    restart_session_msg: "Please restart the session.",
    restart_session_btn: "Restart Session",
    session_ending: "Session Ending...",
    thanks: "Thank you!",
    // Payment
    payment_checking: "Checking Payment",
    please_wait_short: "Please wait...",
    payment_success: "Payment Successful!",
    payment_success_msg: "Your package is activated. You can start practicing right away.",
    go_dashboard: "Go to Dashboard",
    payment_error: "Something Went Wrong",
    payment_error_msg: "Payment status could not be verified. Please check from the dashboard.",
    payment_cancelled: "Payment Cancelled",
    payment_cancelled_msg: "The payment was cancelled. You can try again anytime.",
    go_dashboard_back: "Back to Dashboard",
    // Account
    my_account: "My Account",
    account_info: "Account Information",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    password_changed_success: "Password changed successfully",
    password_change_failed: "Failed to change password",
  },
  tr: {
    po_digital_consent: "Satın aldığım dijital hizmetin ödeme sonrasında hemen kullanıma sunulmasını açıkça kabul ediyorum ve hizmeti kullanmaya başlamamın cayma hakkımı etkileyebileceğini anlıyorum.",
    show_translation: "Çeviriyi göster",
    hide_translation: "Çeviriyi gizle",
    lesson_answers_translation: "İşte doğru cevaplar. Puanın en üstte gösteriliyor ve her sorunun doğru seçeneği yeşille işaretlidir.",
    // Login
    login_title: "Giriş Yap",
    login_subtitle: "Hesabınıza giriş yapın",
    email: "E-posta",
    password: "Şifre",
    login_btn: "Giriş Yap",
    no_account: "Hesabınız yok mu?",
    register_link: "Kayıt Ol",
    fill_all_fields: "Lütfen tüm alanları doldurun",
    login_success: "Giriş başarılı!",
    login_failed: "Giriş başarısız",
    // Register
    register_title: "Kayıt Ol",
    register_subtitle: "Hemen ücretsiz hesap oluşturun",
    full_name: "Ad Soyad",
    full_name_placeholder: "Adınız Soyadınız",
    identity_no: "Kimlik No (Opsiyonel)",
    identity_no_placeholder: "T.C. Kimlik No",
    password_confirm: "Şifre Tekrar",
    register_btn: "Kayıt Ol",
    have_account: "Zaten hesabınız var mı?",
    login_link: "Giriş Yap",
    fill_required: "Lütfen zorunlu alanları doldurun",
    passwords_not_match: "Şifreler eşleşmiyor",
    password_min_length: "Şifre en az 6 karakter olmalı",
    register_success: "Kayıt başarılı!",
    register_failed: "Kayıt başarısız",
    native_language: "Anadiliniz:",
    select_language: "Dil seçin",
    // Dashboard
    hello: "Merhaba,",
    logout: "Çıkış",
    welcome: "Hoş Geldiniz!",
    continue_practice: "Pratiğinize devam edin",
    active_package: "Aktif Paket",
    purchase_date: "Satın Alma",
    start_date: "Başlama",
    end_date: "Bitiş",
    remaining_days: "Kalan",
    days: "gün",
    remaining_sessions: "Kalan Oturum",
    select_lesson: "OTURUM AÇMAK İSTEDİĞİNİZ DERSİ SEÇİNİZ",
    session_start_failed: "Oturum başlatılamadı",
    remaining_credits: "Kalan Kredi",
    start_practice: "Pratiğe Başla",
    listen_lesson: "Dersi Dinle",
    lesson_preparing: "Emma dersinizi hazırlıyor...",
    lesson_please_wait: "Bu yalnızca birkaç saniye sürer.",
    lesson_replay: "Tekrar Dinle",
    lesson_back: "Panele Dön",
    lesson_now_playing: "Emma anlatıyor",
    lesson_score: "Skor",
    lesson_correct: "Doğru",
    lesson_incorrect: "Yanlış",
    lesson_your_answer: "Senin cevabın",
    lesson_correct_answer: "Doğru cevap",
    lesson_not_answered: "Cevaplanmadı",
    insufficient_credits: "Yeterli krediniz yok.",
    lesson_next: "İleri",
    lesson_prev: "Geri",
    lesson_finish: "Bitir",
    payment_start_failed: "Ödeme başlatılamadı",
    combo_packages: "Kombo Paketler",
    combo_subtitle: "Birden fazla seviyeyi bir arada alın, tasarruf edin",
    discount: "İNDİRİM",
    combo: "Kombo",
    included_packages: "İçerdiği paketler:",
    buy_combo: "Kombo Satın Al",
    select_package: "Paket Seçin",
    select_package_subtitle: "Seviyenize uygun paketi seçerek başlayın",
    sessions_count: "oturum",
    total_credits_label: "Toplam Kredi",
    minutes_per_session: "dk/oturum",
    credit_rule_lesson: "1 ders = 5 kredi",
    credit_rule_practice: "1 pratik oturumu = 10 kredi",
    overall_performance: "Genel Performans",
    progress_report: "Gelişim Raporu",
    total_sessions: "Toplam Oturum",
    best_score: "En İyi Skor",
    average_score: "Doğru Cevap",
    session_history: "Oturum Geçmişi",
    lesson_breakdown: "Ders Bazlı Performans",
    minutes: "dk",
    days_access: "gün erişim",
    po_title: "Sipariş Onayı",
    po_summary: "Sipariş Özeti",
    po_included: "İçindeki paketler",
    po_total: "Toplam",
    po_vat_note: "Fiyatlara tüm vergiler dahildir.",
    po_pay_method: "Ödeme yöntemi: Kredi / banka kartı",
    po_agree_intro: "Okudum ve onaylıyorum:",
    po_terms: "Kullanım Koşulları",
    po_privacy: "Gizlilik Politikası",
    po_refund: "İade Politikası",
    po_and: "ve",
    po_secure: "3D Secure ile güvenli ödeme",
    po_proceed: "Ödemeye Devam Et",
    po_cancel: "Vazgeç",
    ai_practice: "AI destekli pratik",
    buy: "Satın Al",
    my_languages: "Dillerim",
    add_language: "Başka dil ekle",
    language_switched: "Dil değiştirildi",
    add_language_title: "Yeni dil ekle",
    choose_language_to_add: "Öğrenmek istediğiniz dili seçin",
    tagline: "Konuşmanın en akıllı yolu",
    // Practice Session
    emma_speaking: "EMMA KONUŞUYOR",
    press_speak: "BAS - KONUŞ",
    stop_speaking: "KONUŞMAYI BİTİR",
    please_wait: "BEKLEYİN...",
    cant_hear: "SİZİ DUYAMADIM",
    cant_hear_retry: "Seni duyamadım. Tekrar söyler misin?",
    repeat_correct: "DOĞRU CEVABI TEKRAR EDİN",
    listening_to_you: "SİZİ DİNLİYORUM",
    repeat_please: "TEKRAR EDİN",
    full_sentence_answer: "TAM CÜMLE CEVAP VERİN",
    exit_session: "Çıkış",
    mic_error: "Mikrofon erişimi sağlanamadı",
    connection_error: "Bağlantı Hatası",
    restart_session_msg: "Lütfen oturumu yeniden başlatın.",
    restart_session_btn: "Oturumu Yeniden Başlat",
    session_ending: "Oturum Sona Eriyor...",
    thanks: "Teşekkürler!",
    // Payment
    payment_checking: "Ödeme Kontrol Ediliyor",
    please_wait_short: "Lütfen bekleyin...",
    payment_success: "Ödeme Başarılı!",
    payment_success_msg: "Paketiniz aktif edildi. Hemen pratik yapmaya başlayabilirsiniz.",
    go_dashboard: "Dashboard'a Git",
    payment_error: "Bir Sorun Oluştu",
    payment_error_msg: "Ödeme durumu kontrol edilemedi. Lütfen dashboard'dan kontrol edin.",
    payment_cancelled: "Ödeme İptal Edildi",
    payment_cancelled_msg: "Ödeme işlemi iptal edildi. İstediğiniz zaman tekrar deneyebilirsiniz.",
    go_dashboard_back: "Dashboard'a Dön",
    // Account
    my_account: "Hesabım",
    account_info: "Hesap Bilgileri",
    change_password: "Şifre Değiştir",
    current_password: "Mevcut Şifre",
    new_password: "Yeni Şifre",
    password_changed_success: "Şifre başarıyla değiştirildi",
    password_change_failed: "Şifre değiştirme başarısız",
  },
  de: {
    po_digital_consent: "Ich stimme ausdrücklich zu, dass die von mir erworbene digitale Dienstleistung unmittelbar nach der Zahlung bereitgestellt wird, und mir ist bewusst, dass die Nutzung der Dienstleistung mein Widerrufsrecht beeinträchtigen kann.",
    my_languages: "Meine Sprachen",
    add_language: "Weitere Sprache hinzufügen",
    language_switched: "Sprache gewechselt",
    add_language_title: "Neue Sprache hinzufügen",
    choose_language_to_add: "Wählen Sie die Sprache, die Sie lernen möchten",
    po_title: "Bestellbestätigung",
    po_summary: "Bestellübersicht",
    po_included: "Enthaltene Pakete",
    po_total: "Gesamt",
    po_vat_note: "Alle anwendbaren Steuern inbegriffen.",
    po_pay_method: "Zahlungsmethode: Kredit- / Debitkarte",
    po_agree_intro: "Ich habe gelesen und akzeptiere:",
    po_terms: "Nutzungsbedingungen",
    po_privacy: "Datenschutzrichtlinie",
    po_refund: "Rückerstattungsrichtlinie",
    po_and: "und",
    po_secure: "Sichere Zahlung mit 3D Secure",
    po_proceed: "Weiter zur Zahlung",
    po_cancel: "Abbrechen",
    show_translation: "Übersetzung anzeigen",
    hide_translation: "Übersetzung ausblenden",
    lesson_answers_translation: "Hier sind die richtigen Antworten. Deine Punktzahl steht oben, und die richtige Option jeder Frage ist grün markiert.",
    login_title: "Anmelden",
    login_subtitle: "Melden Sie sich bei Ihrem Konto an",
    email: "E-Mail",
    password: "Passwort",
    login_btn: "Anmelden",
    no_account: "Kein Konto?",
    register_link: "Registrieren",
    fill_all_fields: "Bitte füllen Sie alle Felder aus",
    login_success: "Anmeldung erfolgreich!",
    login_failed: "Anmeldung fehlgeschlagen",
    register_title: "Registrieren",
    register_subtitle: "Erstellen Sie jetzt ein kostenloses Konto",
    full_name: "Vollständiger Name",
    full_name_placeholder: "Ihr vollständiger Name",
    identity_no: "Ausweisnummer (Optional)",
    identity_no_placeholder: "Ausweisnummer",
    password_confirm: "Passwort bestätigen",
    register_btn: "Registrieren",
    have_account: "Haben Sie bereits ein Konto?",
    login_link: "Anmelden",
    fill_required: "Bitte füllen Sie die Pflichtfelder aus",
    passwords_not_match: "Passwörter stimmen nicht überein",
    password_min_length: "Passwort muss mindestens 6 Zeichen lang sein",
    register_success: "Registrierung erfolgreich!",
    register_failed: "Registrierung fehlgeschlagen",
    native_language: "Muttersprache",
    select_language: "Sprache wählen",
    hello: "Hallo,",
    logout: "Abmelden",
    welcome: "Willkommen!",
    continue_practice: "Setzen Sie Ihre Übungen fort",
    active_package: "Aktives Paket",
    purchase_date: "Kaufdatum",
    start_date: "Startdatum",
    end_date: "Enddatum",
    remaining_days: "Verbleibend",
    days: "Tage",
    remaining_sessions: "Verbleibende Sitzungen",
    select_lesson: "WÄHLEN SIE DIE LEKTION, DIE SIE BEGINNEN MÖCHTEN",
    session_start_failed: "Sitzung konnte nicht gestartet werden",
    remaining_credits: "Verbleibende Credits",
    start_practice: "Übung starten",
    listen_lesson: "Lektion anhören",
    lesson_preparing: "Emma bereitet deine Lektion vor...",
    lesson_please_wait: "Das dauert nur einen Moment.",
    lesson_replay: "Erneut anhören",
    lesson_back: "Zurück zum Dashboard",
    lesson_now_playing: "Emma erklärt",
    lesson_score: "Punktzahl",
    lesson_correct: "Richtig",
    lesson_incorrect: "Falsch",
    lesson_your_answer: "Deine Antwort",
    lesson_correct_answer: "Richtige Antwort",
    lesson_not_answered: "Nicht beantwortet",
    insufficient_credits: "Du hast nicht genügend Credits.",
    lesson_next: "Weiter",
    lesson_prev: "Zurück",
    lesson_finish: "Fertig",
    payment_start_failed: "Zahlung konnte nicht gestartet werden",
    combo_packages: "Kombi-Pakete",
    combo_subtitle: "Mehrere Stufen zusammen kaufen und sparen",
    discount: "RABATT",
    combo: "Kombi",
    included_packages: "Enthaltene Pakete:",
    buy_combo: "Kombi kaufen",
    select_package: "Paket wählen",
    select_package_subtitle: "Wählen Sie das passende Paket für Ihr Niveau",
    sessions_count: "Sitzungen",
    total_credits_label: "Gesamtguthaben",
    minutes_per_session: "Min/Sitzung",
    credit_rule_lesson: "1 Lektion = 5 Credits",
    credit_rule_practice: "1 Übung = 10 Credits",
    overall_performance: "Gesamtleistung",
    progress_report: "Fortschrittsbericht",
    total_sessions: "Sitzungen Insgesamt",
    best_score: "Beste Punktzahl",
    average_score: "Richtige Antwort",
    session_history: "Sitzungsverlauf",
    lesson_breakdown: "Leistung nach Lektion",
    minutes: "Min",
    days_access: "Tage Zugang",
    ai_practice: "KI-unterstütztes Üben",
    buy: "Kaufen",
    tagline: "Der intelligenteste Weg zu sprechen",
    emma_speaking: "EMMA SPRICHT",
    press_speak: "DRÜCKEN - SPRECHEN",
    stop_speaking: "AUFNAHME BEENDEN",
    please_wait: "BITTE WARTEN...",
    cant_hear: "KONNTE SIE NICHT HÖREN",
    cant_hear_retry: "Ich konnte dich nicht hören. Kannst du es wiederholen?",
    repeat_correct: "BITTE WIEDERHOLEN SIE DIE RICHTIGE ANTWORT",
    listening_to_you: "ICH HÖRE IHNEN ZU",
    repeat_please: "WIEDERHOLEN SIE BITTE",
    full_sentence_answer: "ANTWORTEN SIE IN GANZEN SÄTZEN",
    exit_session: "Beenden",
    mic_error: "Mikrofonzugriff fehlgeschlagen",
    connection_error: "Verbindungsfehler",
    restart_session_msg: "Bitte starten Sie die Sitzung neu.",
    restart_session_btn: "Sitzung neu starten",
    session_ending: "Sitzung endet...",
    thanks: "Danke!",
    payment_checking: "Zahlung wird überprüft",
    please_wait_short: "Bitte warten...",
    payment_success: "Zahlung erfolgreich!",
    payment_success_msg: "Ihr Paket wurde aktiviert. Sie können sofort mit dem Üben beginnen.",
    go_dashboard: "Zum Dashboard",
    payment_error: "Ein Problem ist aufgetreten",
    payment_error_msg: "Zahlungsstatus konnte nicht überprüft werden. Bitte überprüfen Sie das Dashboard.",
    payment_cancelled: "Zahlung abgebrochen",
    payment_cancelled_msg: "Die Zahlung wurde abgebrochen. Sie können es jederzeit erneut versuchen.",
    go_dashboard_back: "Zurück zum Dashboard",
    my_account: "Mein Konto",
    account_info: "Kontoinformationen",
    change_password: "Passwort ändern",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    password_changed_success: "Passwort erfolgreich geändert",
    password_change_failed: "Passwortänderung fehlgeschlagen",
  },
  it: {
    po_digital_consent: "Accetto espressamente che il servizio digitale acquistato venga reso disponibile immediatamente dopo il pagamento e comprendo che iniziare a utilizzare il servizio può influire sul mio diritto di recesso.",
    my_languages: "Le mie lingue",
    add_language: "Aggiungi un'altra lingua",
    language_switched: "Lingua cambiata",
    add_language_title: "Aggiungi una nuova lingua",
    choose_language_to_add: "Scegli la lingua che vuoi imparare",
    po_title: "Conferma dell'ordine",
    po_summary: "Riepilogo ordine",
    po_included: "Pacchetti inclusi",
    po_total: "Totale",
    po_vat_note: "Tutte le tasse applicabili incluse.",
    po_pay_method: "Metodo di pagamento: carta di credito / debito",
    po_agree_intro: "Ho letto e accetto:",
    po_terms: "Termini di utilizzo",
    po_privacy: "Informativa sulla privacy",
    po_refund: "Politica di rimborso",
    po_and: "e",
    po_secure: "Pagamento sicuro con 3D Secure",
    po_proceed: "Procedi al pagamento",
    po_cancel: "Annulla",
    show_translation: "Mostra traduzione",
    hide_translation: "Nascondi traduzione",
    lesson_answers_translation: "Ecco le risposte corrette. Il tuo punteggio è mostrato in alto e l'opzione corretta di ogni domanda è evidenziata in verde.",
    login_title: "Accedi",
    login_subtitle: "Accedi al tuo account",
    email: "E-mail",
    password: "Password",
    login_btn: "Accedi",
    no_account: "Non hai un account?",
    register_link: "Registrati",
    fill_all_fields: "Compila tutti i campi",
    login_success: "Accesso riuscito!",
    login_failed: "Accesso fallito",
    register_title: "Registrati",
    register_subtitle: "Crea subito un account gratuito",
    full_name: "Nome e Cognome",
    full_name_placeholder: "Il tuo nome e cognome",
    identity_no: "Codice Fiscale (Opzionale)",
    identity_no_placeholder: "Codice Fiscale",
    password_confirm: "Conferma Password",
    register_btn: "Registrati",
    have_account: "Hai già un account?",
    login_link: "Accedi",
    fill_required: "Compila i campi obbligatori",
    passwords_not_match: "Le password non corrispondono",
    password_min_length: "La password deve avere almeno 6 caratteri",
    register_success: "Registrazione riuscita!",
    register_failed: "Registrazione fallita",
    native_language: "Lingua madre",
    select_language: "Seleziona lingua",
    hello: "Ciao,",
    logout: "Esci",
    welcome: "Benvenuto!",
    continue_practice: "Continua a praticare",
    active_package: "Pacchetto Attivo",
    purchase_date: "Data di acquisto",
    start_date: "Data di inizio",
    end_date: "Data di fine",
    remaining_days: "Rimanenti",
    days: "giorni",
    remaining_sessions: "Sessioni Rimanenti",
    select_lesson: "SELEZIONA LA LEZIONE CHE VUOI INIZIARE",
    session_start_failed: "Impossibile avviare la sessione",
    remaining_credits: "Crediti Rimanenti",
    start_practice: "Inizia Pratica",
    listen_lesson: "Ascolta la Lezione",
    lesson_preparing: "Emma sta preparando la tua lezione...",
    lesson_please_wait: "Ci vorrà solo un momento.",
    lesson_replay: "Riascolta",
    lesson_back: "Torna alla Dashboard",
    lesson_now_playing: "Emma sta spiegando",
    lesson_score: "Punteggio",
    lesson_correct: "Corretto",
    lesson_incorrect: "Sbagliato",
    lesson_your_answer: "La tua risposta",
    lesson_correct_answer: "Risposta corretta",
    lesson_not_answered: "Senza risposta",
    insufficient_credits: "Non hai crediti sufficienti.",
    lesson_next: "Avanti",
    lesson_prev: "Indietro",
    lesson_finish: "Fine",
    payment_start_failed: "Impossibile avviare il pagamento",
    combo_packages: "Pacchetti Combo",
    combo_subtitle: "Acquista più livelli insieme e risparmia",
    discount: "SCONTO",
    combo: "Combo",
    included_packages: "Pacchetti inclusi:",
    buy_combo: "Acquista Combo",
    select_package: "Scegli un Pacchetto",
    select_package_subtitle: "Scegli il pacchetto adatto al tuo livello",
    sessions_count: "sessioni",
    total_credits_label: "Crediti totali",
    minutes_per_session: "min/sessione",
    credit_rule_lesson: "1 lezione = 5 crediti",
    credit_rule_practice: "1 pratica = 10 crediti",
    overall_performance: "Prestazione Generale",
    progress_report: "Rapporto di Progresso",
    total_sessions: "Sessioni Totali",
    best_score: "Miglior Punteggio",
    average_score: "Risposta Corretta",
    session_history: "Cronologia Sessioni",
    lesson_breakdown: "Performance per Lezione",
    minutes: "min",
    days_access: "giorni di accesso",
    ai_practice: "Pratica con AI",
    buy: "Acquista",
    tagline: "Il modo più intelligente per parlare",
    emma_speaking: "EMMA STA PARLANDO",
    press_speak: "PREMI - PARLA",
    stop_speaking: "TERMINA REGISTRAZIONE",
    please_wait: "ATTENDERE...",
    cant_hear: "NON TI HO SENTITO",
    cant_hear_retry: "Non ti ho sentito. Puoi ripetere?",
    repeat_correct: "RIPETI LA RISPOSTA CORRETTA",
    listening_to_you: "TI ASCOLTO",
    repeat_please: "RIPETI",
    full_sentence_answer: "RISPONDI CON FRASI COMPLETE",
    exit_session: "Esci",
    mic_error: "Accesso al microfono non riuscito",
    connection_error: "Errore di Connessione",
    restart_session_msg: "Riavvia la sessione.",
    restart_session_btn: "Riavvia Sessione",
    session_ending: "Sessione in chiusura...",
    thanks: "Grazie!",
    payment_checking: "Controllo Pagamento",
    please_wait_short: "Attendere...",
    payment_success: "Pagamento Riuscito!",
    payment_success_msg: "Il tuo pacchetto è stato attivato. Puoi iniziare subito a praticare.",
    go_dashboard: "Vai alla Dashboard",
    payment_error: "Si è verificato un problema",
    payment_error_msg: "Impossibile verificare lo stato del pagamento. Controlla dalla dashboard.",
    payment_cancelled: "Pagamento Annullato",
    payment_cancelled_msg: "Il pagamento è stato annullato. Puoi riprovare in qualsiasi momento.",
    go_dashboard_back: "Torna alla Dashboard",
    my_account: "Il mio Account",
    account_info: "Informazioni Account",
    change_password: "Cambia Password",
    current_password: "Password Attuale",
    new_password: "Nuova Password",
    password_changed_success: "Password cambiata con successo",
    password_change_failed: "Cambio password fallito",
  },
  es: {
    po_digital_consent: "Acepto expresamente que el servicio digital que compro se ponga a disposición inmediatamente después del pago y entiendo que empezar a usar el servicio puede afectar a mi derecho de desistimiento.",
    my_languages: "Mis idiomas",
    add_language: "Añadir otro idioma",
    language_switched: "Idioma cambiado",
    add_language_title: "Añadir un nuevo idioma",
    choose_language_to_add: "Elige el idioma que quieres aprender",
    po_title: "Confirmación del pedido",
    po_summary: "Resumen del pedido",
    po_included: "Paquetes incluidos",
    po_total: "Total",
    po_vat_note: "Todos los impuestos aplicables incluidos.",
    po_pay_method: "Método de pago: tarjeta de crédito / débito",
    po_agree_intro: "He leído y acepto:",
    po_terms: "Términos de uso",
    po_privacy: "Política de privacidad",
    po_refund: "Política de reembolso",
    po_and: "y",
    po_secure: "Pago seguro con 3D Secure",
    po_proceed: "Continuar al pago",
    po_cancel: "Cancelar",
    show_translation: "Mostrar traducción",
    hide_translation: "Ocultar traducción",
    lesson_answers_translation: "Estas son las respuestas correctas. Tu puntuación aparece arriba y la opción correcta de cada pregunta está marcada en verde.",
    login_title: "Iniciar Sesión",
    login_subtitle: "Inicia sesión en tu cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    login_btn: "Iniciar Sesión",
    no_account: "¿No tienes cuenta?",
    register_link: "Regístrate",
    fill_all_fields: "Por favor, completa todos los campos",
    login_success: "¡Inicio de sesión exitoso!",
    login_failed: "Error al iniciar sesión",
    register_title: "Regístrate",
    register_subtitle: "Crea una cuenta gratuita ahora",
    full_name: "Nombre Completo",
    full_name_placeholder: "Tu nombre completo",
    identity_no: "Número de Identidad (Opcional)",
    identity_no_placeholder: "Número de Identidad",
    password_confirm: "Confirmar Contraseña",
    register_btn: "Regístrate",
    have_account: "¿Ya tienes una cuenta?",
    login_link: "Iniciar Sesión",
    fill_required: "Por favor, completa los campos obligatorios",
    passwords_not_match: "Las contraseñas no coinciden",
    password_min_length: "La contraseña debe tener al menos 6 caracteres",
    register_success: "¡Registro exitoso!",
    register_failed: "Error en el registro",
    native_language: "Idioma nativo",
    select_language: "Seleccionar idioma",
    hello: "Hola,",
    logout: "Cerrar Sesión",
    welcome: "¡Bienvenido!",
    continue_practice: "Continúa practicando",
    active_package: "Paquete Activo",
    purchase_date: "Fecha de compra",
    start_date: "Fecha de inicio",
    end_date: "Fecha de fin",
    remaining_days: "Restantes",
    days: "días",
    remaining_sessions: "Sesiones Restantes",
    select_lesson: "SELECCIONA LA LECCIÓN QUE QUIERES COMENZAR",
    session_start_failed: "No se pudo iniciar la sesión",
    remaining_credits: "Créditos Restantes",
    start_practice: "Iniciar Práctica",
    listen_lesson: "Escuchar la Lección",
    lesson_preparing: "Emma está preparando tu lección...",
    lesson_please_wait: "Solo tomará un momento.",
    lesson_replay: "Volver a Escuchar",
    lesson_back: "Volver al Panel",
    lesson_now_playing: "Emma está explicando",
    lesson_score: "Puntuación",
    lesson_correct: "Correcto",
    lesson_incorrect: "Incorrecto",
    lesson_your_answer: "Tu respuesta",
    lesson_correct_answer: "Respuesta correcta",
    lesson_not_answered: "Sin responder",
    insufficient_credits: "No tienes créditos suficientes.",
    lesson_next: "Siguiente",
    lesson_prev: "Atrás",
    lesson_finish: "Finalizar",
    payment_start_failed: "No se pudo iniciar el pago",
    combo_packages: "Paquetes Combo",
    combo_subtitle: "Compra varios niveles juntos y ahorra",
    discount: "DESCUENTO",
    combo: "Combo",
    included_packages: "Paquetes incluidos:",
    buy_combo: "Comprar Combo",
    select_package: "Elige un Paquete",
    select_package_subtitle: "Elige el paquete adecuado para tu nivel",
    sessions_count: "sesiones",
    total_credits_label: "Créditos totales",
    minutes_per_session: "min/sesión",
    credit_rule_lesson: "1 lección = 5 créditos",
    credit_rule_practice: "1 práctica = 10 créditos",
    overall_performance: "Rendimiento General",
    progress_report: "Informe de Progreso",
    total_sessions: "Sesiones Totales",
    best_score: "Mejor Puntuación",
    average_score: "Respuesta Correcta",
    session_history: "Historial de Sesiones",
    lesson_breakdown: "Rendimiento por Lección",
    minutes: "min",
    days_access: "días de acceso",
    ai_practice: "Práctica con IA",
    buy: "Comprar",
    tagline: "La forma más inteligente de hablar",
    emma_speaking: "EMMA ESTÁ HABLANDO",
    press_speak: "PULSA - HABLA",
    stop_speaking: "TERMINAR GRABACIÓN",
    please_wait: "ESPERE...",
    cant_hear: "NO TE ESCUCHÉ",
    cant_hear_retry: "No te escuché. ¿Puedes repetir?",
    repeat_correct: "REPITA LA RESPUESTA CORRECTA",
    listening_to_you: "TE ESCUCHO",
    repeat_please: "REPITA",
    full_sentence_answer: "RESPONDA CON FRASES COMPLETAS",
    exit_session: "Salir",
    mic_error: "No se pudo acceder al micrófono",
    connection_error: "Error de Conexión",
    restart_session_msg: "Por favor, reinicia la sesión.",
    restart_session_btn: "Reiniciar Sesión",
    session_ending: "Sesión terminando...",
    thanks: "¡Gracias!",
    payment_checking: "Verificando Pago",
    please_wait_short: "Por favor espere...",
    payment_success: "¡Pago Exitoso!",
    payment_success_msg: "Tu paquete ha sido activado. Puedes empezar a practicar ahora.",
    go_dashboard: "Ir al Panel",
    payment_error: "Ocurrió un Problema",
    payment_error_msg: "No se pudo verificar el estado del pago. Revisa desde el panel.",
    payment_cancelled: "Pago Cancelado",
    payment_cancelled_msg: "El pago fue cancelado. Puedes intentarlo de nuevo cuando quieras.",
    go_dashboard_back: "Volver al Panel",
    my_account: "Mi Cuenta",
    account_info: "Información de la Cuenta",
    change_password: "Cambiar Contraseña",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    password_changed_success: "Contraseña cambiada con éxito",
    password_change_failed: "Error al cambiar la contraseña",
  },
  fr: {
    po_digital_consent: "J'accepte expressément que le service numérique que j'achète soit mis à disposition immédiatement après le paiement, et je comprends que commencer à utiliser le service peut affecter mon droit de rétractation.",
    my_languages: "Mes langues",
    add_language: "Ajouter une autre langue",
    language_switched: "Langue changée",
    add_language_title: "Ajouter une nouvelle langue",
    choose_language_to_add: "Choisissez la langue que vous souhaitez apprendre",
    po_title: "Confirmation de commande",
    po_summary: "Récapitulatif de la commande",
    po_included: "Forfaits inclus",
    po_total: "Total",
    po_vat_note: "Toutes les taxes applicables incluses.",
    po_pay_method: "Moyen de paiement : carte de crédit / débit",
    po_agree_intro: "J'ai lu et j'accepte :",
    po_terms: "Conditions d'utilisation",
    po_privacy: "Politique de confidentialité",
    po_refund: "Politique de remboursement",
    po_and: "et",
    po_secure: "Paiement sécurisé avec 3D Secure",
    po_proceed: "Procéder au paiement",
    po_cancel: "Annuler",
    show_translation: "Afficher la traduction",
    hide_translation: "Masquer la traduction",
    lesson_answers_translation: "Voici les bonnes réponses. Ton score est affiché en haut, et la bonne option de chaque question est marquée en vert.",
    login_title: "Connexion",
    login_subtitle: "Connectez-vous à votre compte",
    email: "E-mail",
    password: "Mot de passe",
    login_btn: "Se connecter",
    no_account: "Pas de compte ?",
    register_link: "S'inscrire",
    fill_all_fields: "Veuillez remplir tous les champs",
    login_success: "Connexion réussie !",
    login_failed: "Échec de la connexion",
    register_title: "S'inscrire",
    register_subtitle: "Créez un compte gratuit maintenant",
    full_name: "Nom Complet",
    full_name_placeholder: "Votre nom complet",
    identity_no: "Numéro d'identité (Optionnel)",
    identity_no_placeholder: "Numéro d'identité",
    password_confirm: "Confirmer le mot de passe",
    register_btn: "S'inscrire",
    have_account: "Vous avez déjà un compte ?",
    login_link: "Se connecter",
    fill_required: "Veuillez remplir les champs obligatoires",
    passwords_not_match: "Les mots de passe ne correspondent pas",
    password_min_length: "Le mot de passe doit contenir au moins 6 caractères",
    register_success: "Inscription réussie !",
    register_failed: "Échec de l'inscription",
    native_language: "Langue maternelle",
    select_language: "Choisir la langue",
    hello: "Bonjour,",
    logout: "Déconnexion",
    welcome: "Bienvenue !",
    continue_practice: "Continuez à pratiquer",
    active_package: "Forfait Actif",
    purchase_date: "Date d'achat",
    start_date: "Date de début",
    end_date: "Date de fin",
    remaining_days: "Restants",
    days: "jours",
    remaining_sessions: "Séances Restantes",
    select_lesson: "SÉLECTIONNEZ LA LEÇON QUE VOUS SOUHAITEZ COMMENCER",
    session_start_failed: "Impossible de démarrer la séance",
    remaining_credits: "Crédits Restants",
    start_practice: "Commencer la Pratique",
    listen_lesson: "Écouter la Leçon",
    lesson_preparing: "Emma prépare votre leçon...",
    lesson_please_wait: "Cela ne prendra qu'un instant.",
    lesson_replay: "Réécouter",
    lesson_back: "Retour au Tableau de Bord",
    lesson_now_playing: "Emma explique",
    lesson_score: "Score",
    lesson_correct: "Correct",
    lesson_incorrect: "Incorrect",
    lesson_your_answer: "Ta réponse",
    lesson_correct_answer: "Bonne réponse",
    lesson_not_answered: "Sans réponse",
    insufficient_credits: "Vous n'avez pas assez de crédits.",
    lesson_next: "Suivant",
    lesson_prev: "Précédent",
    lesson_finish: "Terminer",
    payment_start_failed: "Impossible de démarrer le paiement",
    combo_packages: "Forfaits Combo",
    combo_subtitle: "Achetez plusieurs niveaux ensemble et économisez",
    discount: "RÉDUCTION",
    combo: "Combo",
    included_packages: "Forfaits inclus :",
    buy_combo: "Acheter le Combo",
    select_package: "Choisir un Forfait",
    select_package_subtitle: "Choisissez le forfait adapté à votre niveau",
    sessions_count: "séances",
    total_credits_label: "Crédits totaux",
    minutes_per_session: "min/séance",
    credit_rule_lesson: "1 leçon = 5 crédits",
    credit_rule_practice: "1 session = 10 crédits",
    overall_performance: "Performance Globale",
    progress_report: "Rapport de Progression",
    total_sessions: "Total des Séances",
    best_score: "Meilleur Score",
    average_score: "Bonne Réponse",
    session_history: "Historique des Séances",
    lesson_breakdown: "Performance par Leçon",
    minutes: "min",
    days_access: "jours d'accès",
    ai_practice: "Pratique avec IA",
    buy: "Acheter",
    tagline: "La façon la plus intelligente de parler",
    emma_speaking: "EMMA PARLE",
    press_speak: "APPUYEZ - PARLEZ",
    stop_speaking: "ARRÊTER L'ENREGISTREMENT",
    please_wait: "VEUILLEZ PATIENTER...",
    cant_hear: "JE NE VOUS AI PAS ENTENDU",
    cant_hear_retry: "Je ne t'ai pas entendu. Peux-tu répéter ?",
    repeat_correct: "RÉPÉTEZ LA BONNE RÉPONSE",
    listening_to_you: "JE VOUS ÉCOUTE",
    repeat_please: "RÉPÉTEZ",
    full_sentence_answer: "RÉPONDEZ EN PHRASES COMPLÈTES",
    exit_session: "Sortir",
    mic_error: "Accès au microphone échoué",
    connection_error: "Erreur de Connexion",
    restart_session_msg: "Veuillez redémarrer la séance.",
    restart_session_btn: "Redémarrer la Séance",
    session_ending: "Séance en cours de fermeture...",
    thanks: "Merci !",
    payment_checking: "Vérification du Paiement",
    please_wait_short: "Veuillez patienter...",
    payment_success: "Paiement Réussi !",
    payment_success_msg: "Votre forfait a été activé. Vous pouvez commencer à pratiquer immédiatement.",
    go_dashboard: "Aller au Tableau de bord",
    payment_error: "Un Problème est Survenu",
    payment_error_msg: "Impossible de vérifier le statut du paiement. Veuillez vérifier le tableau de bord.",
    payment_cancelled: "Paiement Annulé",
    payment_cancelled_msg: "Le paiement a été annulé. Vous pouvez réessayer quand vous le souhaitez.",
    go_dashboard_back: "Retour au Tableau de bord",
    my_account: "Mon Compte",
    account_info: "Informations du Compte",
    change_password: "Changer le Mot de Passe",
    current_password: "Mot de Passe Actuel",
    new_password: "Nouveau Mot de Passe",
    password_changed_success: "Mot de passe changé avec succès",
    password_change_failed: "Échec du changement de mot de passe",
  },
  ru: {
    po_digital_consent: "Я прямо соглашаюсь с тем, что приобретаемая цифровая услуга будет предоставлена сразу после оплаты, и понимаю, что начало использования услуги может повлиять на моё право на отказ.",
    my_languages: "Мои языки",
    add_language: "Добавить другой язык",
    language_switched: "Язык изменён",
    add_language_title: "Добавить новый язык",
    choose_language_to_add: "Выберите язык, который хотите изучать",
    po_title: "Подтверждение заказа",
    po_summary: "Сводка заказа",
    po_included: "Включённые пакеты",
    po_total: "Итого",
    po_vat_note: "Все применимые налоги включены.",
    po_pay_method: "Способ оплаты: кредитная / дебетовая карта",
    po_agree_intro: "Я прочитал и принимаю:",
    po_terms: "Условия использования",
    po_privacy: "Политика конфиденциальности",
    po_refund: "Политика возврата",
    po_and: "и",
    po_secure: "Безопасная оплата с 3D Secure",
    po_proceed: "Перейти к оплате",
    po_cancel: "Отмена",
    show_translation: "Показать перевод",
    hide_translation: "Скрыть перевод",
    lesson_answers_translation: "Вот правильные ответы. Твой результат показан вверху, а правильный вариант каждого вопроса отмечен зелёным.",
    login_title: "Войти",
    login_subtitle: "Войдите в свой аккаунт",
    email: "Электронная почта",
    password: "Пароль",
    login_btn: "Войти",
    no_account: "Нет аккаунта?",
    register_link: "Зарегистрироваться",
    fill_all_fields: "Пожалуйста, заполните все поля",
    login_success: "Вход выполнен успешно!",
    login_failed: "Ошибка входа",
    register_title: "Регистрация",
    register_subtitle: "Создайте бесплатный аккаунт прямо сейчас",
    full_name: "Полное имя",
    full_name_placeholder: "Ваше полное имя",
    identity_no: "Номер удостоверения (Необязательно)",
    identity_no_placeholder: "Номер удостоверения",
    password_confirm: "Подтвердите пароль",
    register_btn: "Зарегистрироваться",
    have_account: "Уже есть аккаунт?",
    login_link: "Войти",
    fill_required: "Пожалуйста, заполните обязательные поля",
    passwords_not_match: "Пароли не совпадают",
    password_min_length: "Пароль должен содержать минимум 6 символов",
    register_success: "Регистрация успешна!",
    register_failed: "Ошибка регистрации",
    native_language: "Родной язык",
    select_language: "Выберите язык",
    hello: "Привет,",
    logout: "Выйти",
    welcome: "Добро пожаловать!",
    continue_practice: "Продолжайте заниматься",
    active_package: "Активный Пакет",
    purchase_date: "Дата покупки",
    start_date: "Дата начала",
    end_date: "Дата окончания",
    remaining_days: "Осталось",
    days: "дней",
    remaining_sessions: "Оставшиеся Сеансы",
    select_lesson: "ВЫБЕРИТЕ УРОК, КОТОРЫЙ ХОТИТЕ НАЧАТЬ",
    session_start_failed: "Не удалось начать сеанс",
    remaining_credits: "Оставшиеся Кредиты",
    start_practice: "Начать Практику",
    listen_lesson: "Прослушать Урок",
    lesson_preparing: "Эмма готовит ваш урок...",
    lesson_please_wait: "Это займёт всего мгновение.",
    lesson_replay: "Прослушать Снова",
    lesson_back: "Назад к Панели",
    lesson_now_playing: "Эмма объясняет",
    lesson_score: "Балл",
    lesson_correct: "Верно",
    lesson_incorrect: "Неверно",
    lesson_your_answer: "Ваш ответ",
    lesson_correct_answer: "Правильный ответ",
    lesson_not_answered: "Без ответа",
    insufficient_credits: "У вас недостаточно кредитов.",
    lesson_next: "Далее",
    lesson_prev: "Назад",
    lesson_finish: "Готово",
    payment_start_failed: "Не удалось начать оплату",
    combo_packages: "Комбо-Пакеты",
    combo_subtitle: "Купите несколько уровней вместе и сэкономьте",
    discount: "СКИДКА",
    combo: "Комбо",
    included_packages: "Включённые пакеты:",
    buy_combo: "Купить Комбо",
    select_package: "Выберите Пакет",
    select_package_subtitle: "Выберите пакет, подходящий вашему уровню",
    sessions_count: "сеансов",
    total_credits_label: "Всего кредитов",
    minutes_per_session: "мин/сессия",
    credit_rule_lesson: "1 урок = 5 кредитов",
    credit_rule_practice: "1 практика = 10 кредитов",
    overall_performance: "Общий Прогресс",
    progress_report: "Отчёт о Прогрессе",
    total_sessions: "Всего Сеансов",
    best_score: "Лучший Результат",
    average_score: "Правильный Ответ",
    session_history: "История Сеансов",
    lesson_breakdown: "Производительность по урокам",
    minutes: "мин",
    days_access: "дней доступа",
    ai_practice: "Практика с ИИ",
    buy: "Купить",
    tagline: "Самый умный способ говорить",
    emma_speaking: "ЭММА ГОВОРИТ",
    press_speak: "НАЖМИ - ГОВОРИ",
    stop_speaking: "ОСТАНОВИТЬ ЗАПИСЬ",
    please_wait: "ПОДОЖДИТЕ...",
    cant_hear: "НЕ РАССЛЫШАЛ ВАС",
    cant_hear_retry: "Я тебя не расслышал. Можешь повторить?",
    repeat_correct: "ПОВТОРИТЕ ПРАВИЛЬНЫЙ ОТВЕТ",
    listening_to_you: "Я ВАС СЛУШАЮ",
    repeat_please: "ПОВТОРИТЕ",
    full_sentence_answer: "ОТВЕЧАЙТЕ ПОЛНЫМИ ПРЕДЛОЖЕНИЯМИ",
    exit_session: "Выйти",
    mic_error: "Не удалось получить доступ к микрофону",
    connection_error: "Ошибка Соединения",
    restart_session_msg: "Пожалуйста, перезапустите сеанс.",
    restart_session_btn: "Перезапустить Сеанс",
    session_ending: "Сеанс завершается...",
    thanks: "Спасибо!",
    payment_checking: "Проверка Оплаты",
    please_wait_short: "Пожалуйста, подождите...",
    payment_success: "Оплата Успешна!",
    payment_success_msg: "Ваш пакет активирован. Вы можете начать практику прямо сейчас.",
    go_dashboard: "Перейти в Панель",
    payment_error: "Возникла Проблема",
    payment_error_msg: "Не удалось проверить статус оплаты. Проверьте в панели управления.",
    payment_cancelled: "Оплата Отменена",
    payment_cancelled_msg: "Оплата была отменена. Вы можете попробовать снова в любое время.",
    go_dashboard_back: "Вернуться в Панель",
    my_account: "Мой Аккаунт",
    account_info: "Информация об аккаунте",
    change_password: "Изменить Пароль",
    current_password: "Текущий Пароль",
    new_password: "Новый Пароль",
    password_changed_success: "Пароль успешно изменён",
    password_change_failed: "Не удалось изменить пароль",
  },
  cnr: {
    po_digital_consent: "Izričito prihvatam da mi digitalna usluga koju kupujem bude dostupna odmah nakon plaćanja i razumijem da početak korišćenja usluge može uticati na moje pravo na odustajanje.",
    my_languages: "Moji jezici",
    add_language: "Dodaj još jedan jezik",
    language_switched: "Jezik promijenjen",
    add_language_title: "Dodaj novi jezik",
    choose_language_to_add: "Izaberite jezik koji želite da učite",
    show_translation: "Prikaži prijevod",
    hide_translation: "Sakrij prijevod",
    lesson_answers_translation: "Evo tačnih odgovora. Tvoj rezultat je prikazan na vrhu, a tačna opcija za svako pitanje označena je zelenom bojom.",
    po_title: "Potvrda narudžbe",
    po_summary: "Pregled narudžbe",
    po_included: "Uključeni paketi",
    po_total: "Ukupno",
    po_vat_note: "Svi primjenjivi porezi uključeni.",
    po_pay_method: "Način plaćanja: kreditna / debitna kartica",
    po_agree_intro: "Pročitao sam i prihvatam:",
    po_terms: "Uslovi korišćenja",
    po_privacy: "Politika privatnosti",
    po_refund: "Politika povraćaja",
    po_and: "i",
    po_secure: "Sigurno plaćanje uz 3D Secure",
    po_proceed: "Nastavi na plaćanje",
    po_cancel: "Otkaži",
    login_title: "Prijava",
    login_subtitle: "Prijavite se na vaš nalog",
    email: "E-pošta",
    password: "Lozinka",
    login_btn: "Prijavi se",
    no_account: "Nemate nalog?",
    register_link: "Registrujte se",
    fill_all_fields: "Molimo popunite sva polja",
    login_success: "Prijava uspješna!",
    login_failed: "Prijava neuspješna",
    register_title: "Registracija",
    register_subtitle: "Kreirajte besplatan nalog odmah",
    full_name: "Ime i Prezime",
    full_name_placeholder: "Vaše ime i prezime",
    identity_no: "Broj lične karte (Opcionalno)",
    identity_no_placeholder: "Broj lične karte",
    password_confirm: "Potvrdite lozinku",
    register_btn: "Registrujte se",
    have_account: "Već imate nalog?",
    login_link: "Prijavi se",
    fill_required: "Molimo popunite obavezna polja",
    passwords_not_match: "Lozinke se ne poklapaju",
    password_min_length: "Lozinka mora imati najmanje 6 karaktera",
    register_success: "Registracija uspješna!",
    register_failed: "Registracija neuspješna",
    native_language: "Maternji jezik",
    select_language: "Izaberite jezik",
    hello: "Zdravo,",
    logout: "Odjavi se",
    welcome: "Dobrodošli!",
    continue_practice: "Nastavite sa vježbanjem",
    active_package: "Aktivni Paket",
    purchase_date: "Datum kupovine",
    start_date: "Datum početka",
    end_date: "Datum završetka",
    remaining_days: "Preostalo",
    days: "dana",
    remaining_sessions: "Preostale Sesije",
    select_lesson: "IZABERITE LEKCIJU KOJU ŽELITE ZAPOČETI",
    session_start_failed: "Sesija nije mogla biti pokrenuta",
    remaining_credits: "Preostali Krediti",
    start_practice: "Započni Vježbu",
    listen_lesson: "Preslušaj Lekciju",
    lesson_preparing: "Ema priprema vašu lekciju...",
    lesson_replay: "Preslušaj Ponovo",
    lesson_back: "Nazad na Kontrolnu Tablu",
    lesson_now_playing: "Ema objašnjava",
    lesson_score: "Rezultat",
    lesson_correct: "Tačno",
    lesson_incorrect: "Netačno",
    lesson_your_answer: "Tvoj odgovor",
    lesson_correct_answer: "Tačan odgovor",
    lesson_not_answered: "Bez odgovora",
    insufficient_credits: "Nemate dovoljno kredita.",
    lesson_next: "Sljedeće",
    lesson_please_wait: "Trajaće samo trenutak.",
    lesson_prev: "Nazad",
    lesson_finish: "Završi",
    payment_start_failed: "Plaćanje nije moglo biti pokrenuto",
    combo_packages: "Kombo Paketi",
    combo_subtitle: "Kupite više nivoa zajedno i uštedite",
    discount: "POPUST",
    combo: "Kombo",
    included_packages: "Uključeni paketi:",
    buy_combo: "Kupi Kombo",
    select_package: "Izaberite Paket",
    select_package_subtitle: "Izaberite paket koji odgovara vašem nivou",
    sessions_count: "sesija",
    total_credits_label: "Ukupno kredita",
    minutes_per_session: "min/sesija",
    credit_rule_lesson: "1 lekcija = 5 kredita",
    credit_rule_practice: "1 vježba = 10 kredita",
    overall_performance: "Ukupna Performansa",
    progress_report: "Izvještaj o Napretku",
    total_sessions: "Ukupno Sesija",
    best_score: "Najbolji Rezultat",
    average_score: "Tačan Odgovor",
    session_history: "Istorija Sesija",
    lesson_breakdown: "Performansa po Lekciji",
    minutes: "min",
    days_access: "dana pristupa",
    ai_practice: "Vježbanje sa AI",
    buy: "Kupi",
    tagline: "Najpametniji način da govorite",
    emma_speaking: "EMMA GOVORI",
    press_speak: "PRITISNI - GOVORI",
    stop_speaking: "ZAVRŠI SNIMANJE",
    please_wait: "SAČEKAJTE...",
    cant_hear: "NISAM VAS ČUO/LA",
    cant_hear_retry: "Nisam te čuo/la. Možeš li ponoviti?",
    repeat_correct: "PONOVITE TAČAN ODGOVOR",
    listening_to_you: "SLUŠAM VAS",
    repeat_please: "PONOVITE",
    full_sentence_answer: "ODGOVORITE CIJELOM REČENICOM",
    exit_session: "Izlaz",
    mic_error: "Pristup mikrofonu nije uspio",
    connection_error: "Greška u Povezivanju",
    restart_session_msg: "Molimo ponovo pokrenite sesiju.",
    restart_session_btn: "Ponovo Pokreni Sesiju",
    session_ending: "Sesija se završava...",
    thanks: "Hvala!",
    payment_checking: "Provjera Plaćanja",
    please_wait_short: "Molimo sačekajte...",
    payment_success: "Plaćanje Uspješno!",
    payment_success_msg: "Vaš paket je aktiviran. Možete odmah početi vježbati.",
    go_dashboard: "Idi na Panel",
    payment_error: "Došlo je do Problema",
    payment_error_msg: "Status plaćanja nije mogao biti provjeren. Provjerite na panelu.",
    payment_cancelled: "Plaćanje Otkazano",
    payment_cancelled_msg: "Plaćanje je otkazano. Možete pokušati ponovo kad god želite.",
    go_dashboard_back: "Nazad na Panel",
    my_account: "Moj Nalog",
    account_info: "Informacije o Nalogu",
    change_password: "Promijeni Lozinku",
    current_password: "Trenutna Lozinka",
    new_password: "Nova Lozinka",
    password_changed_success: "Lozinka uspješno promijenjena",
    password_change_failed: "Promjena lozinke neuspješna",
  },
  sr: {
    po_digital_consent: "Izričito prihvatam da mi digitalna usluga koju kupujem bude dostupna odmah nakon plaćanja i razumem da početak korišćenja usluge može uticati na moje pravo na odustanak.",
    my_languages: "Moji jezici",
    add_language: "Dodaj još jedan jezik",
    language_switched: "Jezik promenjen",
    add_language_title: "Dodaj novi jezik",
    choose_language_to_add: "Izaberite jezik koji želite da učite",
    po_title: "Potvrda porudžbine",
    po_summary: "Pregled porudžbine",
    po_included: "Uključeni paketi",
    po_total: "Ukupno",
    po_vat_note: "Svi primenjivi porezi uključeni.",
    po_pay_method: "Način plaćanja: kreditna / debitna kartica",
    po_agree_intro: "Pročitao sam i prihvatam:",
    po_terms: "Uslovi korišćenja",
    po_privacy: "Politika privatnosti",
    po_refund: "Politika povraćaja",
    po_and: "i",
    po_secure: "Sigurno plaćanje uz 3D Secure",
    po_proceed: "Nastavi na plaćanje",
    po_cancel: "Otkaži",
    show_translation: "Prikaži prevod",
    hide_translation: "Sakrij prevod",
    lesson_answers_translation: "Evo tačnih odgovora. Tvoj rezultat je prikazan na vrhu, a tačna opcija za svako pitanje označena je zelenom bojom.",
    // Login
    login_title: "Prijavite se",
    login_subtitle: "Prijavite se na svoj nalog",
    email: "E-pošta",
    password: "Lozinka",
    login_btn: "Prijavite se",
    no_account: "Nemate nalog?",
    register_link: "Registrujte se",
    fill_all_fields: "Molimo popunite sva polja",
    login_success: "Uspešna prijava!",
    login_failed: "Prijava neuspešna",
    register_title: "Registracija",
    register_subtitle: "Kreirajte besplatan nalog",
    full_name: "Ime i Prezime",
    full_name_placeholder: "Vaše Ime i Prezime",
    identity_no: "Lični broj (Opciono)",
    identity_no_placeholder: "Lični broj",
    password_confirm: "Ponovite Lozinku",
    register_btn: "Registrujte se",
    have_account: "Već imate nalog?",
    login_link: "Prijavite se",
    fill_required: "Molimo popunite obavezna polja",
    passwords_not_match: "Lozinke se ne poklapaju",
    password_min_length: "Lozinka mora imati najmanje 6 karaktera",
    register_success: "Uspešna registracija!",
    register_failed: "Registracija neuspešna",
    native_language: "Vaš maternji jezik:",
    select_language: "Izaberite jezik",
    hello: "Zdravo,",
    logout: "Odjavite se",
    welcome: "Dobrodošli!",
    continue_practice: "Nastavite sa vežbanjem",
    active_package: "Aktivan Paket",
    purchase_date: "Datum Kupovine",
    start_date: "Početak",
    end_date: "Kraj",
    remaining_days: "Preostalo",
    days: "dana",
    remaining_sessions: "Preostale Sesije",
    select_lesson: "IZABERITE LEKCIJU ZA OTVARANJE SESIJE",
    session_start_failed: "Pokretanje sesije neuspešno",
    remaining_credits: "Preostali Krediti",
    start_practice: "Započni Vežbu",
    listen_lesson: "Preslušaj Lekciju",
    lesson_preparing: "Ema priprema vašu lekciju...",
    lesson_replay: "Preslušaj Ponovo",
    lesson_back: "Nazad na Kontrolnu Tablu",
    lesson_now_playing: "Ema objašnjava",
    lesson_score: "Rezultat",
    lesson_correct: "Tačno",
    lesson_incorrect: "Netačno",
    lesson_your_answer: "Tvoj odgovor",
    lesson_correct_answer: "Tačan odgovor",
    lesson_not_answered: "Bez odgovora",
    insufficient_credits: "Nemate dovoljno kredita.",
    lesson_next: "Sledeće",
    lesson_please_wait: "Trajaće samo trenutak.",
    lesson_prev: "Nazad",
    lesson_finish: "Završi",
    payment_start_failed: "Pokretanje plaćanja neuspešno",
    combo_packages: "Kombo Paketi",
    combo_subtitle: "Uzmite više nivoa zajedno i uštedite",
    discount: "POPUST",
    combo: "Kombo",
    included_packages: "Uključeni paketi:",
    buy_combo: "Kupi Kombo",
    select_package: "Izaberite Paket",
    select_package_subtitle: "Izaberite paket koji odgovara vašem nivou",
    sessions_count: "sesija",
    total_credits_label: "Ukupno kredita",
    minutes_per_session: "min/sesija",
    credit_rule_lesson: "1 lekcija = 5 kredita",
    credit_rule_practice: "1 vežba = 10 kredita",
    overall_performance: "Ukupna Performansa",
    progress_report: "Izveštaj o Napretku",
    total_sessions: "Ukupno Sesija",
    best_score: "Najbolji Rezultat",
    average_score: "Tačan Odgovor",
    session_history: "Istorija Sesija",
    lesson_breakdown: "Performansa po Lekciji",
    minutes: "min",
    days_access: "dana pristupa",
    ai_practice: "AI vežba",
    buy: "Kupi",
    tagline: "Najpametniji način da govorite",
    emma_speaking: "EMA GOVORI",
    press_speak: "PRITISNI - GOVORI",
    stop_speaking: "ZAVRŠI SNIMANJE",
    please_wait: "SAČEKAJTE...",
    cant_hear: "NISAM VAS ČUO/LA",
    cant_hear_retry: "Nisam te čuo/la. Možeš li ponoviti?",
    repeat_correct: "PONOVITE TAČAN ODGOVOR",
    listening_to_you: "SLUŠAM VAS",
    repeat_please: "PONOVITE",
    full_sentence_answer: "ODGOVORITE CELOM REČENICOM",
    exit_session: "Izlaz",
    mic_error: "Pristup mikrofonu nije uspeo",
    connection_error: "Greška u Povezivanju",
    restart_session_msg: "Molimo ponovo pokrenite sesiju.",
    restart_session_btn: "Ponovo Pokreni Sesiju",
    session_ending: "Sesija se završava...",
    thanks: "Hvala!",
    payment_checking: "Provera Plaćanja",
    please_wait_short: "Molimo sačekajte...",
    payment_success: "Plaćanje Uspešno!",
    payment_success_msg: "Vaš paket je aktiviran. Možete odmah početi da vežbate.",
    go_dashboard: "Idi na Panel",
    payment_error: "Došlo je do Problema",
    payment_error_msg: "Status plaćanja nije mogao biti proveren. Proverite na panelu.",
    payment_cancelled: "Plaćanje Otkazano",
    payment_cancelled_msg: "Plaćanje je otkazano. Možete pokušati ponovo kad god želite.",
    go_dashboard_back: "Nazad na Panel",
    my_account: "Moj Nalog",
    account_info: "Informacije o Nalogu",
    change_password: "Promeni Lozinku",
    current_password: "Trenutna Lozinka",
    new_password: "Nova Lozinka",
    password_changed_success: "Lozinka uspešno promenjena",
    password_change_failed: "Promena lozinke neuspešna",
  },
  sq: {
    po_digital_consent: "Pranoj shprehimisht që shërbimi dixhital që blej të vihet në dispozicion menjëherë pas pagesës dhe kuptoj që fillimi i përdorimit të shërbimit mund të ndikojë në të drejtën time të tërheqjes.",
    my_languages: "Gjuhët e mia",
    add_language: "Shto një gjuhë tjetër",
    language_switched: "Gjuha u ndryshua",
    add_language_title: "Shto një gjuhë të re",
    choose_language_to_add: "Zgjidhni gjuhën që dëshironi të mësoni",
    po_title: "Konfirmimi i porosisë",
    po_summary: "Përmbledhja e porosisë",
    po_included: "Paketat e përfshira",
    po_total: "Totali",
    po_vat_note: "Të gjitha taksat e zbatueshme përfshihen.",
    po_pay_method: "Mënyra e pagesës: kartë krediti / debiti",
    po_agree_intro: "Kam lexuar dhe pranoj:",
    po_terms: "Kushtet e përdorimit",
    po_privacy: "Politika e privatësisë",
    po_refund: "Politika e rimbursimit",
    po_and: "dhe",
    po_secure: "Pagesë e sigurt me 3D Secure",
    po_proceed: "Vazhdo te pagesa",
    po_cancel: "Anulo",
    show_translation: "Shfaq përkthimin",
    hide_translation: "Fshih përkthimin",
    lesson_answers_translation: "Këto janë përgjigjet e sakta. Rezultati yt shfaqet lart dhe opsioni i saktë për çdo pyetje është shënuar me jeshile.",
    // Login
    login_title: "Hyr",
    login_subtitle: "Hyni në llogarinë tënde",
    email: "E-mail",
    password: "Fjalëkalimi",
    login_btn: "Hyr",
    no_account: "Nuk ke llogari?",
    register_link: "Regjistrohu",
    fill_all_fields: "Ju lutem plotësoni të gjitha fushat",
    login_success: "Hyrje e suksesshme!",
    login_failed: "Hyrja dështoi",
    register_title: "Regjistrohu",
    register_subtitle: "Krijo një llogari falas tani",
    full_name: "Emri dhe Mbiemri",
    full_name_placeholder: "Emri juaj dhe Mbiemri",
    identity_no: "Numri i Identitetit (Opsionale)",
    identity_no_placeholder: "Numri i Identitetit",
    password_confirm: "Konfirmo Fjalëkalimin",
    register_btn: "Regjistrohu",
    have_account: "Ke tashmë një llogari?",
    login_link: "Hyr",
    fill_required: "Ju lutem plotësoni fushat e detyrueshme",
    passwords_not_match: "Fjalëkalimet nuk përputhen",
    password_min_length: "Fjalëkalimi duhet të ketë të paktën 6 karaktere",
    register_success: "Regjistrim i suksesshëm!",
    register_failed: "Regjistrimi dështoi",
    native_language: "Gjuha juaj amtare:",
    select_language: "Zgjidhni gjuhën",
    hello: "Përshëndetje,",
    logout: "Dil",
    welcome: "Mirë se vini!",
    continue_practice: "Vazhdoni praktikën tuaj",
    active_package: "Paketa Aktive",
    purchase_date: "Data e Blerjes",
    start_date: "Fillimi",
    end_date: "Mbarimi",
    remaining_days: "Të mbetura",
    days: "ditë",
    remaining_sessions: "Sesionet e Mbetura",
    select_lesson: "ZGJIDHNI NJË MËSIM PËR TË HAPUR NJË SESION",
    session_start_failed: "Nisja e sesionit dështoi",
    remaining_credits: "Kreditet e Mbetura",
    start_practice: "Fillo Praktikën",
    listen_lesson: "Dëgjo Mësimin",
    lesson_preparing: "Emma po përgatit mësimin tuaj...",
    lesson_please_wait: "Do të zgjasë vetëm një moment.",
    lesson_replay: "Dëgjo Përsëri",
    lesson_back: "Kthehu te Paneli",
    lesson_now_playing: "Emma po shpjegon",
    lesson_score: "Rezultati",
    lesson_correct: "Saktë",
    lesson_incorrect: "Gabim",
    lesson_your_answer: "Përgjigja jote",
    lesson_correct_answer: "Përgjigja e saktë",
    lesson_not_answered: "Pa përgjigje",
    insufficient_credits: "Nuk keni kredite të mjaftueshme.",
    lesson_next: "Tjetra",
    lesson_prev: "Prapa",
    lesson_finish: "Përfundo",
    payment_start_failed: "Nisja e pagesës dështoi",
    combo_packages: "Paketat Kombo",
    combo_subtitle: "Merrni disa nivele së bashku dhe kurseni",
    discount: "ZBRITJE",
    combo: "Kombo",
    included_packages: "Paketat e përfshira:",
    buy_combo: "Bli Kombo",
    select_package: "Zgjidhni Paketën",
    select_package_subtitle: "Zgjidhni paketën që i përshtatet nivelit tuaj",
    sessions_count: "sesione",
    total_credits_label: "Kredite gjithsej",
    minutes_per_session: "min/seancë",
    credit_rule_lesson: "1 mësim = 5 kredite",
    credit_rule_practice: "1 praktikë = 10 kredite",
    overall_performance: "Performanca e Përgjithshme",
    progress_report: "Raporti i Progresit",
    total_sessions: "Sesionet Gjithsej",
    best_score: "Rezultati Më i Mirë",
    average_score: "Përgjigjja e Saktë",
    session_history: "Historiku i Sesioneve",
    lesson_breakdown: "Performanca sipas Mësimit",
    minutes: "min",
    days_access: "ditë akses",
    ai_practice: "Praktikë me AI",
    buy: "Bli",
    tagline: "Mënyra më e zgjuar për të folur",
    emma_speaking: "EMA PO FLET",
    press_speak: "SHTYP - FLIT",
    stop_speaking: "NDALO REGJISTRIMIN",
    please_wait: "PRISNI...",
    cant_hear: "NUK JU DËGJOVA",
    cant_hear_retry: "Nuk të dëgjova. A mund ta përsërisësh?",
    repeat_correct: "PËRSËRITNI PËRGJIGJEN E SAKTË",
    listening_to_you: "PO JU DËGJOJ",
    repeat_please: "PËRSËRITNI",
    full_sentence_answer: "PËRGJIGJUNI ME FJALI TË PLOTA",
    exit_session: "Dil",
    mic_error: "Qasja në mikrofon dështoi",
    connection_error: "Gabim në Lidhje",
    restart_session_msg: "Ju lutem rinis sesionin.",
    restart_session_btn: "Rinis Sesionin",
    session_ending: "Sesioni po përfundon...",
    thanks: "Faleminderit!",
    payment_checking: "Kontrolli i Pagesës",
    please_wait_short: "Ju lutem prisni...",
    payment_success: "Pagesa e Suksesshme!",
    payment_success_msg: "Paketa juaj është aktivizuar. Mund të filloni praktikën menjëherë.",
    go_dashboard: "Shko te Paneli",
    payment_error: "Ndodhi një Problem",
    payment_error_msg: "Statusi i pagesës nuk mund të verifikohet. Kontrolloni në panel.",
    payment_cancelled: "Pagesa u Anulua",
    payment_cancelled_msg: "Pagesa u anulua. Mund të provoni përsëri kur të dëshironi.",
    go_dashboard_back: "Kthehu te Paneli",
    my_account: "Llogaria Ime",
    account_info: "Informacionet e Llogarisë",
    change_password: "Ndrysho Fjalëkalimin",
    current_password: "Fjalëkalimi Aktual",
    new_password: "Fjalëkalimi i Ri",
    password_changed_success: "Fjalëkalimi u ndryshua me sukses",
    password_change_failed: "Ndryshimi i fjalëkalimit dështoi",
  },
  el: {
    po_digital_consent: "Αποδέχομαι ρητά ότι η ψηφιακή υπηρεσία που αγοράζω θα καταστεί διαθέσιμη αμέσως μετά την πληρωμή και κατανοώ ότι η έναρξη χρήσης της υπηρεσίας ενδέχεται να επηρεάσει το δικαίωμα υπαναχώρησής μου.",
    my_languages: "Οι γλώσσες μου",
    add_language: "Προσθήκη άλλης γλώσσας",
    language_switched: "Η γλώσσα άλλαξε",
    add_language_title: "Προσθήκη νέας γλώσσας",
    choose_language_to_add: "Επιλέξτε τη γλώσσα που θέλετε να μάθετε",
    po_title: "Επιβεβαίωση παραγγελίας",
    po_summary: "Σύνοψη παραγγελίας",
    po_included: "Περιλαμβανόμενα πακέτα",
    po_total: "Σύνολο",
    po_vat_note: "Περιλαμβάνονται όλοι οι ισχύοντες φόροι.",
    po_pay_method: "Τρόπος πληρωμής: πιστωτική / χρεωστική κάρτα",
    po_agree_intro: "Έχω διαβάσει και αποδέχομαι:",
    po_terms: "Όροι χρήσης",
    po_privacy: "Πολιτική απορρήτου",
    po_refund: "Πολιτική επιστροφής χρημάτων",
    po_and: "και",
    po_secure: "Ασφαλής πληρωμή με 3D Secure",
    po_proceed: "Συνέχεια στην πληρωμή",
    po_cancel: "Ακύρωση",
    show_translation: "Εμφάνιση μετάφρασης",
    hide_translation: "Απόκρυψη μετάφρασης",
    lesson_answers_translation: "Εδώ είναι οι σωστές απαντήσεις. Η βαθμολογία σου εμφανίζεται στην κορυφή και η σωστή επιλογή κάθε ερώτησης είναι σημειωμένη με πράσινο.",
    // Login
    login_title: "Σύνδεση",
    login_subtitle: "Συνδεθείτε στον λογαριασμό σας",
    email: "E-mail",
    password: "Κωδικός",
    login_btn: "Σύνδεση",
    no_account: "Δεν έχετε λογαριασμό;",
    register_link: "Εγγραφή",
    fill_all_fields: "Παρακαλώ συμπληρώστε όλα τα πεδία",
    login_success: "Επιτυχής σύνδεση!",
    login_failed: "Η σύνδεση απέτυχε",
    register_title: "Εγγραφή",
    register_subtitle: "Δημιουργήστε δωρεάν λογαριασμό",
    full_name: "Ονοματεπώνυμο",
    full_name_placeholder: "Το Ονοματεπώνυμό σας",
    identity_no: "Αριθμός Ταυτότητας (Προαιρετικό)",
    identity_no_placeholder: "Αριθμός Ταυτότητας",
    password_confirm: "Επιβεβαίωση Κωδικού",
    register_btn: "Εγγραφή",
    have_account: "Έχετε ήδη λογαριασμό;",
    login_link: "Σύνδεση",
    fill_required: "Παρακαλώ συμπληρώστε τα υποχρεωτικά πεδία",
    passwords_not_match: "Οι κωδικοί δεν ταιριάζουν",
    password_min_length: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
    register_success: "Επιτυχής εγγραφή!",
    register_failed: "Η εγγραφή απέτυχε",
    native_language: "Η μητρική σας γλώσσα:",
    select_language: "Επιλέξτε γλώσσα",
    hello: "Γεια σας,",
    logout: "Αποσύνδεση",
    welcome: "Καλώς ήρθατε!",
    continue_practice: "Συνεχίστε την εξάσκηση",
    active_package: "Ενεργό Πακέτο",
    purchase_date: "Ημ. Αγοράς",
    start_date: "Έναρξη",
    end_date: "Λήξη",
    remaining_days: "Υπόλοιπο",
    days: "ημέρες",
    remaining_sessions: "Υπόλοιπες Συνεδρίες",
    select_lesson: "ΕΠΙΛΕΞΤΕ ΜΑΘΗΜΑ ΓΙΑ ΝΑ ΞΕΚΙΝΗΣΕΤΕ ΣΥΝΕΔΡΙΑ",
    session_start_failed: "Η εκκίνηση συνεδρίας απέτυχε",
    remaining_credits: "Υπόλοιπα Credits",
    start_practice: "Έναρξη Εξάσκησης",
    listen_lesson: "Ακούστε το Μάθημα",
    lesson_preparing: "Η Emma ετοιμάζει το μάθημά σας...",
    lesson_please_wait: "Θα πάρει μόνο μια στιγμή.",
    lesson_replay: "Ακούστε Ξανά",
    lesson_back: "Επιστροφή στον Πίνακα",
    lesson_now_playing: "Η Emma εξηγεί",
    lesson_score: "Βαθμολογία",
    lesson_correct: "Σωστό",
    lesson_incorrect: "Λάθος",
    lesson_your_answer: "Η απάντησή σου",
    lesson_correct_answer: "Σωστή απάντηση",
    lesson_not_answered: "Χωρίς απάντηση",
    insufficient_credits: "Δεν έχετε αρκετά credits.",
    lesson_next: "Επόμενο",
    lesson_prev: "Πίσω",
    lesson_finish: "Τέλος",
    payment_start_failed: "Η εκκίνηση πληρωμής απέτυχε",
    combo_packages: "Πακέτα Κόμπο",
    combo_subtitle: "Πάρτε πολλά επίπεδα μαζί και εξοικονομήστε",
    discount: "ΕΚΠΤΩΣΗ",
    combo: "Κόμπο",
    included_packages: "Περιλαμβανόμενα πακέτα:",
    buy_combo: "Αγορά Κόμπο",
    select_package: "Επιλέξτε Πακέτο",
    select_package_subtitle: "Επιλέξτε το πακέτο που ταιριάζει στο επίπεδό σας",
    sessions_count: "συνεδρίες",
    total_credits_label: "Συνολικά credits",
    minutes_per_session: "λεπτά/συνεδρία",
    credit_rule_lesson: "1 μάθημα = 5 credits",
    credit_rule_practice: "1 εξάσκηση = 10 credits",
    overall_performance: "Συνολική Απόδοση",
    progress_report: "Αναφορά Προόδου",
    total_sessions: "Συνολικές Συνεδρίες",
    best_score: "Καλύτερη Βαθμολογία",
    average_score: "Σωστή Απάντηση",
    session_history: "Ιστορικό Συνεδριών",
    lesson_breakdown: "Επίδοση ανά Μάθημα",
    minutes: "λεπτά",
    days_access: "ημέρες πρόσβασης",
    ai_practice: "Εξάσκηση με AI",
    buy: "Αγορά",
    tagline: "Ο πιο έξυπνος τρόπος να μιλάτε",
    emma_speaking: "Η ΕΜΑ ΜΙΛΑΕΙ",
    press_speak: "ΠΑΤΗΣΤΕ - ΜΙΛΗΣΤΕ",
    stop_speaking: "ΣΤΑΜΑΤΗΣΤΕ ΤΗΝ ΕΓΓΡΑΦΗ",
    please_wait: "ΠΕΡΙΜΕΝΕΤΕ...",
    cant_hear: "ΔΕΝ ΣΑΣ ΑΚΟΥΣΑ",
    cant_hear_retry: "Δεν σε άκουσα. Μπορείς να το επαναλάβεις;",
    repeat_correct: "ΕΠΑΝΑΛΑΒΕΤΕ ΤΗ ΣΩΣΤΗ ΑΠΑΝΤΗΣΗ",
    listening_to_you: "ΣΑΣ ΑΚΟΥΩ",
    repeat_please: "ΕΠΑΝΑΛΑΒΕΤΕ",
    full_sentence_answer: "ΑΠΑΝΤΗΣΤΕ ΜΕ ΠΛΗΡΕΙΣ ΠΡΟΤΑΣΕΙΣ",
    exit_session: "Έξοδος",
    mic_error: "Η πρόσβαση στο μικρόφωνο απέτυχε",
    connection_error: "Σφάλμα Σύνδεσης",
    restart_session_msg: "Παρακαλώ επανεκκινήστε τη συνεδρία.",
    restart_session_btn: "Επανεκκίνηση Συνεδρίας",
    session_ending: "Η Συνεδρία Τελειώνει...",
    thanks: "Ευχαριστώ!",
    payment_checking: "Έλεγχος Πληρωμής",
    please_wait_short: "Παρακαλώ περιμένετε...",
    payment_success: "Επιτυχής Πληρωμή!",
    payment_success_msg: "Το πακέτο σας ενεργοποιήθηκε. Μπορείτε να ξεκινήσετε αμέσως.",
    go_dashboard: "Πηγαίνετε στον Πίνακα",
    payment_error: "Παρουσιάστηκε Πρόβλημα",
    payment_error_msg: "Η κατάσταση πληρωμής δεν μπόρεσε να επαληθευτεί. Ελέγξτε στον πίνακα.",
    payment_cancelled: "Η Πληρωμή Ακυρώθηκε",
    payment_cancelled_msg: "Η πληρωμή ακυρώθηκε. Μπορείτε να δοκιμάσετε ξανά όποτε θέλετε.",
    go_dashboard_back: "Επιστροφή στον Πίνακα",
    my_account: "Ο Λογαριασμός μου",
    account_info: "Πληροφορίες Λογαριασμού",
    change_password: "Αλλαγή Κωδικού",
    current_password: "Τρέχων Κωδικός",
    new_password: "Νέος Κωδικός",
    password_changed_success: "Ο κωδικός άλλαξε επιτυχώς",
    password_change_failed: "Η αλλαγή κωδικού απέτυχε",
  },
};

export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English" },
  { code: "tr", label: "Türkçe" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "ru", label: "Русский" },
  { code: "cnr", label: "Crnogorski" },
  { code: "sr", label: "Srpski" },
  { code: "sq", label: "Shqip" },
  { code: "el", label: "Ελληνικά" },
];

export default translations;
